// Dados iniciais de órgãos do MPU
export const initialMpuData = [
    { type: "MPF", value: 65 },
    { type: "MPT", value: 80 },
    { type: "MPM", value: 45 },
    { type: "MPDFT", value: 95 },
    { type: "CNMP", value: 70 },
    { type: "ESMPU", value: 85 }
  ];